/* Pitch Eleven - cabecalho: carrossel da faixa, menu mobile, cabecalho fixo. */
if (!customElements.get('pe-header')) {
  class PeHeader extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section');
      this.slides = Array.from(this.querySelectorAll('.pe-ann__slide'));
      this.current = Math.max(0, this.slides.findIndex((s) => s.classList.contains('is-active')));
      this.speed = (parseInt(this.dataset.speed, 10) || 5) * 1000;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.onKeydown = this.onKeydown.bind(this);
      this.onScroll = this.onScroll.bind(this);
      this.onBlockSelect = this.onBlockSelect.bind(this);

      this.setupSlider();
      this.setupDrawer();
      this.setupSticky();

      this.setHeaderHeight();
      this.resizeObserver = new ResizeObserver(() => this.setHeaderHeight());
      this.resizeObserver.observe(this);

      document.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    disconnectedCallback() {
      this.stop();
      this.resizeObserver?.disconnect();
      window.removeEventListener('scroll', this.onScroll);
      document.removeEventListener('keydown', this.onKeydown);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      document.body.classList.remove('pe-lock');
    }

    setHeaderHeight() {
      const alvo = this.section || this;
      document.documentElement.style.setProperty('--header-height', `${alvo.offsetHeight}px`);
    }

    /* ---------- Carrossel da faixa ---------- */

    setupSlider() {
      this.toggleButton = this.querySelector('[data-pe-toggle]');
      if (this.slides.length < 2) return;

      this.toggleButton?.addEventListener('click', () => {
        if (this.classList.contains('is-paused')) this.start();
        else this.stop();
      });

      if (this.dataset.autoplay === 'true' && !this.reduced) this.start();
      else this.stop();
    }

    show(index) {
      if (index === this.current) return;
      const saindo = this.slides[this.current];
      const entrando = this.slides[index];
      saindo.classList.remove('is-active');
      saindo.classList.add('is-leaving');
      window.setTimeout(() => saindo.classList.remove('is-leaving'), 460);
      entrando.classList.add('is-active');
      this.current = index;
    }

    next() {
      this.show((this.current + 1) % this.slides.length);
    }

    start() {
      this.stop();
      this.timer = window.setInterval(() => this.next(), this.speed);
      this.classList.remove('is-paused');
      if (this.toggleButton) {
        this.toggleButton.setAttribute('aria-label', 'Pause');
        this.toggleButton.setAttribute('aria-pressed', 'false');
      }
    }

    stop() {
      window.clearInterval(this.timer);
      this.timer = null;
      this.classList.add('is-paused');
      if (this.toggleButton) {
        this.toggleButton.setAttribute('aria-label', 'Play');
        this.toggleButton.setAttribute('aria-pressed', 'true');
      }
    }

    onBlockSelect(event) {
      const slide = event.target.closest?.('.pe-ann__slide');
      if (!slide || !this.contains(slide)) return;
      this.stop();
      this.show(this.slides.indexOf(slide));
    }

    /* ---------- Menu mobile ---------- */

    setupDrawer() {
      this.drawer = this.querySelector('.pe-drawer');
      this.openButton = this.querySelector('[data-pe-open]');
      if (!this.drawer || !this.openButton) return;

      this.openButton.addEventListener('click', () => this.openDrawer());
      this.drawer.querySelectorAll('[data-pe-close]').forEach((el) => el.addEventListener('click', () => this.closeDrawer()));
    }

    openDrawer() {
      this.drawer.classList.add('is-open');
      this.drawer.setAttribute('aria-hidden', 'false');
      this.openButton.setAttribute('aria-expanded', 'true');
      document.body.classList.add('pe-lock');
      document.addEventListener('keydown', this.onKeydown);
      window.setTimeout(() => this.drawer.querySelector('.pe-drawer__panel')?.focus(), 50);
    }

    closeDrawer() {
      if (!this.drawer?.classList.contains('is-open')) return;
      this.drawer.classList.remove('is-open');
      this.drawer.setAttribute('aria-hidden', 'true');
      this.openButton.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('pe-lock');
      document.removeEventListener('keydown', this.onKeydown);
      this.openButton.focus();
    }

    onKeydown(event) {
      if (event.key === 'Escape') this.closeDrawer();
    }

    /* ---------- Cabecalho que aparece ao rolar pra cima ---------- */

    setupSticky() {
      if (this.dataset.sticky !== 'scroll-up' || !this.section) return;
      this.section.style.position = 'sticky';
      this.section.style.top = '0';
      this.section.style.zIndex = '4';
      this.lastY = window.scrollY;
      window.addEventListener('scroll', this.onScroll, { passive: true });
    }

    onScroll() {
      const y = window.scrollY;
      const buscaAberta = this.querySelector('predictive-search[open]');
      if (y > this.lastY && y > this.section.offsetHeight && !buscaAberta) {
        this.section.classList.add('pe-section--hidden');
      } else if (y < this.lastY) {
        this.section.classList.remove('pe-section--hidden');
      }
      this.lastY = y;
    }
  }

  customElements.define('pe-header', PeHeader);
}
